<template>
  <b-modal size="xl" :id="modalId" body-class="p-0" header-class="justify-content-normal">
    <template #modal-header>
      <div class="d-flex flex-wrap justify-content-between w-100 gap-2">
        <h5 class="modal-title">
          Sejarah Cabang {{ cabang ? cabang.name : '-' }}
        </h5>
        <StateDetailHandler :isLoading="stateTotalBalanceCabang.isLoading" :isError="stateTotalBalanceCabang.isError"
          :lines="1" @retry="retry">
          <h5 class="modal-title">
            Saldo: Rp. {{ stateTotalBalanceCabang.data ?
              $helper.addThousandSeparator(stateTotalBalanceCabang.data.cashVirtual) : 0 }}
          </h5>
        </StateDetailHandler>
      </div>
    </template>
    <div class="overflow-auto custom-scrollbar-wrapper">
      <div style="min-width: 600px;">
        <div class="py-3 px-3" style="background-color: #304f7b;">
          <b-row>
            <b-col cols="2">
              <span class="font-weight-bold small text-uppercase text-white">TANGGAL</span>
            </b-col>
            <b-col cols="2">
              <span class="font-weight-bold small text-uppercase text-white">KATEGORI</span>
            </b-col>
            <b-col cols="4">
              <span class="font-weight-bold small text-uppercase text-white">PERUBAHAN KAS VIRTUAL</span>
            </b-col>
            <b-col cols="4">
              <span class="font-weight-bold small text-uppercase text-white">KETERANGAN</span>
            </b-col>
          </b-row>
        </div>
        <StateDetailHandler :isLoading="stateHistory.isLoading" :isError="stateHistory.isError" :lines="4"
          @retry="retry">
          <b-list-group flush v-if="stateHistory.data.length > 0">
            <b-list-group-item v-for="(item, i) in stateHistory.data" :key="i" action
              class="py-3 px-3 border-bottom-light">
              <b-row align-v="center">
                <b-col cols="2">
                  <div class="font-weight-bold text-dark">{{ item.createdAt ? $helper.changeDateFormat(item.createdAt) : '' }}</div>
                  <div class="text-muted small">{{ item.createdAt ? $helper.changeDateFormatGetHour(item.createdAt) : '' }}</div>
                </b-col>
                <b-col cols="2">
                  <div class="font-weight-bold text-dark">{{ item.type == 1 ? 'Transaksi' : 'Manual Finance' }}</div>
                  <div class="text-muted small">{{ item.createdBy }}</div>
                </b-col>
                <b-col cols="4">
                  <div class="d-flex align-items-center">
                    <div class="mr-3 rounded-circle d-flex align-items-center justify-content-center"
                      :class="item.change < 0 ? 'bg-light-danger' : 'bg-light-success'"
                      style="width: 30px; height: 30px;">
                      <i class="fa" :class="[
                          item.change < 0 ? 'fa-arrow-down text-danger' : 'fa-arrow-up text-success'
                        ]" style="font-size: 14px;"></i>
                    </div>
                    <div>
                      <div class="font-weight-bold mb-0" :class="item.change < 0 ? 'text-danger' : 'text-success'">
                        {{ item.change >= 0 ? '+' : '-' }} Rp. {{ $helper.addThousandSeparator(Math.abs(item.change)) }}
                          </div>
                          <div class="small text-muted">
                            Saldo Setelah:
                            <span>Rp. {{ $helper.addThousandSeparator(item.balanceAfter) }}</span>
                          </div>
                      </div>
                    </div>
                </b-col>
                <b-col cols="4">
                  <div style="
                      max-height: 47px;
                      overflow-y: auto;
                      white-space: normal;
                    ">
                    {{ item.notes || '-' }}
                  </div>
                </b-col>
              </b-row>
            </b-list-group-item>
          </b-list-group>
        </StateDetailHandler>
        <div v-if="stateHistory.data.length < 1 && !stateHistory.isLoading">
          <b-row class="text-center py-4 text-muted m-0">
            <b-col>
              <i class="fa fa-inbox mb-2" style="font-size: 28px;"></i>
              <div>Belum ada history untuk cabang ini</div>
            </b-col>
          </b-row>
        </div>
      </div>
    </div>
    <div class="divider mt-0 mb-0"></div>
    <div class="pagination-wrapper d-flex align-items-center justify-content-between p-3">
      <b-input-group prepend="Tampilkan" class="align-items-center tableShowItem">
        <b-form-select v-model="pagination.show" @change="onLimitChange" :options="pagination.optionsLimit">
          <template v-slot:first>
            <b-form-select-option :value="null" disabled />
          </template>
        </b-form-select>
        <span class="ml-2">{{ pagination.totalViewText }}</span>
      </b-input-group>
      <b-pagination class="mb-0" v-model="pagination.currentPage" :total-rows="pagination.totalRows"
        :per-page="pagination.perPage" aria-controls="my-table" @input="onPageChange"></b-pagination>
    </div>
    <template v-slot:modal-footer="{ cancel }">
      <b-button variant="secondary" name="closeEditBtn" @click="cancel()">
        Close
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import StateDetailHandler from '@/components/common/StateDetailHandler'

export default {
  name: "ModalHistoryKasVirtual",
  components: {
    StateDetailHandler,
  },
  props: {
    stateHistory: {
      type: Object,
      required: true,
    },
    pagination: {
      type: Object,
      required: true,
    },
    stateTotalBalanceCabang: {
      type: Object,
      required: true,
    },
    cabang: {
      type: Object,
      default: () => null,
    },
    modalId: {
      type: String,
      default: 'modal-history-kas-virtual',
    },
  },
  methods: {
    retry() {
      this.$emit('retry')
    },
    onLimitChange(newPerPage) {
      this.$emit('onLimitChange', newPerPage)
    },
    onPageChange(newPage) {
      this.$emit('onPageChange', newPage)
    },
  }
}
</script>

<style scoped>
.bg-light-success {
  background-color: #e6fffa;
}

.bg-light-danger {
  background-color: #ffe6e6;
}

.border-bottom-light {
  border-bottom: 1px solid #f0f0f0;
}

.custom-scrollbar-wrapper::-webkit-scrollbar {
  height: 8px;
}

.custom-scrollbar-wrapper::-webkit-scrollbar-thumb {
  background-color: #ced4da;
  border-radius: 4px;
}
</style>